import React from "react";
import { NavLink } from "react-router-dom";

const Navigation = () => {
  return (
    <div className="navigation">
      <ul>
        {/* Partie Front-End */}
        <li className="nav-portfolio">
          Front-End
          <ul className="nav-projects-1">
            <NavLink
              to="/cameleon"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Caméléon</li>
            </NavLink>

            <NavLink
              to="/bulles"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Bulles</li>
            </NavLink>

            <NavLink
              to="/to-do-list"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>To do list</li>
            </NavLink>

            <NavLink
              to="/minuteur"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Minuteur</li>
            </NavLink>

            <NavLink
              to="/vacances"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Vacances</li>
            </NavLink>

            <NavLink
              to="/pays-du-monde"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Pays du monde</li>
            </NavLink>

            <NavLink
              to="/quiz"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Quiz</li>
            </NavLink>

            <NavLink
              to="/flappy-bat"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Flappy bat</li>
            </NavLink>
          </ul>
        </li>
        {/* Partie illustrations */}
        <li className="nav-portfolio">
          Illustrations
          <ul className="nav-projects-2">
            <NavLink
              to="/actus-rh"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Actus RH</li>
            </NavLink>

            <NavLink
              to="/visuels-com"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Visuels de com</li>
            </NavLink>

            <NavLink
              to="/logos"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Logos</li>
            </NavLink>

            <NavLink
              to="/bandes-dessinees"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Bandes dessinées</li>
            </NavLink>

            <NavLink
              to="/editions-jeunesse"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Éditions jeunesse</li>
            </NavLink>

            <NavLink
              to="/pochettes-disques"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Pochettes de disques</li>
            </NavLink>

            <NavLink
              to="/sweat-shirts"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Sweat-shirts</li>
            </NavLink>

            <NavLink
              to="/planches-skate"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Planches de skate</li>
            </NavLink>

            <NavLink
              to="/aeronautique"
              className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
            >
              <li>Aéronautique</li>
            </NavLink>
          </ul>
        </li>

        <NavLink
          to="/contact"
          className={(nav) => (nav.isActive ? "nav-active hover" : "hover")}
        >
          <li>Contact</li>
        </NavLink>
      </ul>
    </div>
  );
};

export default Navigation;
